import { styled, Box } from "@mui/material";

export const ModalWrapper = styled(Box)({
    borderRadius: "10px",
    position: "absolute",
    background: "#e9e9e9",
});